// eslint-disable-next-line local-rules/no-enum
var RoutesMap;
(function (RoutesMap) {
    RoutesMap["pin"] = "/pin";
    RoutesMap["overview"] = "/overview";
    RoutesMap["nurseryGroup"] = "/groups/:groupId";
    RoutesMap["childCheckIn"] = "/child/:childId/checkin";
    RoutesMap["childCheckOut"] = "/child/:childId/checkout";
    RoutesMap["staffGroup"] = "/staff/:staffGroupId";
    RoutesMap["employeeCheckIn"] = "/employee/:employeeId/checkin";
    RoutesMap["employeeCheckOut"] = "/employee/:employeeId/checkout";
    RoutesMap["goHomeWith"] = "/go-home-with/:childId";
    RoutesMap["qr"] = "/qr";
    RoutesMap["guest"] = "/guest";
    RoutesMap["selectChildren"] = "/select-children";
    RoutesMap["selectChildInRoom"] = "/select-child/:childId";
    RoutesMap["selectStaff"] = "/select-staff/:employeeId";
})(RoutesMap || (RoutesMap = {}));
export default RoutesMap;
